import React from "react";
import { Typography, Card, CardContent } from "@material-ui/core";
import * as Contants from "../../Constants/Styles";

const RepoItem = (repo) => {
  const classes = Contants.useStyles();
  console.log(repo);
  return (
    <Card className={classes.repoUserRoot}>
      <CardContent>
        <a href={repo.repo.html_url} style={{ textDecoration: "none" }}>
          <Typography variant="h5" align="center" color="textSecondary">
            {repo.repo.name}
          </Typography>
        </a>
      </CardContent>
    </Card>
  );
};

export default RepoItem;
